import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchedulerItemOnMachineApiAbstract } from './item-on-machine';
import { SchedulerItemOnMachineCRUD } from '../../../api/elite/dto/scheduler-item-on-machine.dto';
import { ApiRouteSchedulingService } from '../../../api/elite/routes/scheduling.service';
import { SchedulerWorkOrderOnMachine } from '../models/wo-on-machine';
import { SchedulerWorkOrder } from '../models/work-order';
import { SchedulerDragDropApiAbstract } from './drag-drop';
import { ApiRouteWorkOrderService } from '../../../api/elite/routes/work-order.service';
import { ApiRouteMachineOrdersService } from '../../../api/elite/routes/machine-orders.service';
import { SchedulingApiRoutesDto } from '../../../api/elite/dto/scheduling.dto';

type AddBody = SchedulerItemOnMachineCRUD['add'];
type UpdateBody = SchedulerItemOnMachineCRUD['update'];
type StopBody = SchedulerItemOnMachineCRUD['stop'];

@Injectable({
  providedIn: 'root',
})
export class SchedulerWorkOrderOnMachineApiService
  implements SchedulerItemOnMachineApiAbstract, SchedulerDragDropApiAbstract
{
  constructor(
    protected readonly schedulingRoutes: ApiRouteSchedulingService,
    protected readonly apiWorkOrderRouter: ApiRouteWorkOrderService,
    // private readonly apiMachineRouter: ApiRouteMachinesService,
    protected readonly apiMachineOrdersRouter: ApiRouteMachineOrdersService
  ) {}

  addItem(body: AddBody): Observable<SchedulerWorkOrderOnMachine> {
    return this.schedulingRoutes.addWorkOrderToMachine(
      body
    ) as undefined as Observable<SchedulerWorkOrderOnMachine>;
  }

  updateItem(body: UpdateBody): Observable<SchedulerWorkOrderOnMachine> {
    return this.schedulingRoutes.moveWorkOrderToOtherMachine(
      body
    ) as unknown as Observable<SchedulerWorkOrderOnMachine>;
  }
  removeItem(workOrderId: number, machineId: number): Observable<any> {
    return this.schedulingRoutes.removeWorkOrderFromMachine(
      workOrderId,
      machineId
    );
  }

  startItemOnMachine(itemId: number, machineId: number): Observable<any> {
    return this.schedulingRoutes.startWorkOrderOnMachine(itemId, machineId);
  }

  stopItemOnMachine(body: StopBody): Observable<
    | SchedulerWorkOrder
    | {
        workOrder: SchedulerWorkOrder;
        newSubWorkOrder: SchedulerWorkOrder;
      }
  > {
    return this.schedulingRoutes.stopWorkOrderOnMachine(
      body
    ) as undefined as Observable<
      | SchedulerWorkOrder
      | {
          workOrder: SchedulerWorkOrder;
          newSubWorkOrder: SchedulerWorkOrder;
        }
    >;
  }

  v2StopItemOnMachine(
    body: SchedulingApiRoutesDto['registerProgress']['body']
  ): Observable<any> {
    return this.schedulingRoutes.registerProgressWorkOrder(body);
  }

  updateRank(itemId: number, rank: string): Observable<any> {
    return this.apiWorkOrderRouter.update(itemId, { rank });
  }

  removeRunning(machineId: number, workOrderId: number): Observable<boolean> {
    return this.apiMachineOrdersRouter.setAsNotRunning(machineId, workOrderId);
  }
}
